module.exports = __webpack_public_path__ + "media/images/dividend/ill-bike-mobile@3x-875fe178a7d39f1df04f5268dd94ada8.png";